import React, {useState} from 'react';
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {injectIntl} from "react-intl";

import {featureInterface} from "./featureInterface";
import SvgIcons from "../../Icons/SvgIcons";
import {featuresSetupUpdateFeature} from "../featuresActions";
import {
  getFeatureEditPermission,
  getNewUnlinkedDataObject,
} from "../featuresFunctions";
import {showNewFeatureOverlay} from "../../FeatureCreator/NewFeature/NewFeatureActions";
import {ToggleLinkPopup} from "../../FeatureCreator/ToggleLinkPopup";
import {messageBoxComponent_Show, toggleWarningOff} from "../../../actions";


const FeaturesSetupFeatureActionsTopLinkButton = (props) => {

  const {feature, featuresSetupUpdateFeature, canEdit, doNotShowLinkWarning, toggleWarningOff, messageBoxComponent_Show,
    intl, catId} = props;
  const [showWarning, setShowWarning] = useState(false);

  const enabledToggle = () => {
    if (!canEdit) {
      return false
    }

    const newData = getNewUnlinkedDataObject(feature, catId);

    const newPropValues = feature.unlinkedData
      ? [null, null, []]
      : [JSON.stringify({[catId]: newData}), newData, []];

    if (!doNotShowLinkWarning) { // TODO
      const message = <ToggleLinkPopup hasUnlinkedData={!!feature.unlinkedData} onChecked={setShowWarning} />;
      const title = intl.formatMessage({id: feature.unlinkedData ? "features.setup.linkPopup.reconnect" : "features.setup.linkPopup.separate"});
      messageBoxComponent_Show(true, 'system', title, message, [{
        text: intl.formatMessage({id: "messageBox.buttons.ok"}),
        onClick: () => {
          messageBoxComponent_Show();  //reset to default props (not visible by default)
          toggleWarningOff(showWarning);
          featuresSetupUpdateFeature(feature, ["unlinkedDataJson", "unlinkedData"],  newPropValues);
        }
      },{
        text: intl.formatMessage({id: "messageBox.buttons.cancel"}),
        onClick: messageBoxComponent_Show
      }])
    } else {
      featuresSetupUpdateFeature(feature, ["unlinkedDataJson", "unlinkedData", "markUpLogic"],  newPropValues);
    }
  }

  return (
    <div className="fs-feature__action">
      <button className={"ui-icon--rounded" + (feature.unlinkedData ? " ui-icon-gray3" : " ui-icon-blue")
        + (canEdit && catId != 0 ? "" : " ui-icon-blue--disabled")}
              onClick={enabledToggle}>
        {feature.unlinkedData ? SvgIcons.unlink : SvgIcons.link}
      </button>
    </div>
  )
};

FeaturesSetupFeatureActionsTopLinkButton.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {catId} = store.featuresSetupState;
  const {canEdit} = getFeatureEditPermission(store);
  const {doNotShowLinkWarning} = store.auth;

  return {
    canEdit,
    catId,
    doNotShowLinkWarning,
  };
};

const mapDispatchToProps = {
  featuresSetupUpdateFeature,
  showNewFeatureOverlay,
  toggleWarningOff,
  messageBoxComponent_Show,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(FeaturesSetupFeatureActionsTopLinkButton)
)
